import { Box, Typography } from '@mui/material';
import parse from 'html-react-parser';
import colors from '@/shared/colors';

interface Props {
  index: number;
  title: string;
  text: string;
}

export const InstructionWrapper = ({ index, title, text }: Props) => {
  return (
    <Box
      sx={{
        padding: '16px 16px 24px 16px',
        backgroundColor: colors.cerulean,
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        height: 'auto',
        width: '280px',
      }}
    >
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '36px',
        }}
      >
        {`0${index}`}
      </Typography>
      <Typography
        sx={{
          fontSize: '10px',
        }}
      >
        {title}
      </Typography>
      <Typography>{parse(text)}</Typography>
    </Box>
  );
};
